module.exports = __webpack_public_path__ + "static/img/imgTodo.fd142b5e.webp";